// src/utils/gtm.js
export const initializeGTM = () => {
  // Replace with your actual GTM ID
  const GTM_ID = process.env.REACT_APP_GTM_ID || "GTM-MBNCCKKJ";

  // Check if GTM is already initialized
  if (window.dataLayer) {
    return;
  }

  // Create dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  // Add GTM script
  const script = document.createElement("script");
  script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  document.head.appendChild(script);

  // Add noscript iframe
  const noscript = document.createElement("noscript");
  noscript.innerHTML = `
    <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>
  `;
  document.body.appendChild(noscript);
};

// Function to push events to GTM
export const pushToGTM = (data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  } else {
  }
};

// Page view tracking
export const trackPageView = (url) => {
  pushToGTM({
    event: "pageview",
    page: url,
  });
};
